// extracted by mini-css-extract-plugin
module.exports = {"finesWrapper":"_2C4WS","finesWrapperDesktop":"nmVqe","finesList":"_2hvRe","fineHeader":"bf6sa","fineText":"TkB0R","seeAllList":"_36sVi"};